import classNames from "classnames";
import React from "react";
import { CircleIcon } from "../../brand/CircleIcon/CircleIcon";

import "./ItineraryMeta.scss";

export interface ItineraryMetaProps {
  /**
   * Time from now the itinerary was sent
   */
  sentTime: string;

  /**
   * Name of the author
   */
  author: string;

  /**
   * Itinerary version number
   */
  versionNumber: number;

  /**
   * Whether it's the current itinerary or not
   */
  isCurrentItinerary: boolean;
}

/**
 * Itinerary Header
 *
 * @status stable
 */
export const ItineraryMeta: React.FC<ItineraryMetaProps> = ({
  sentTime, author, versionNumber, isCurrentItinerary
}) => {
  return (
    <header className="itinerary-meta">
      <h1 className="itinerary-meta__heading">
        {isCurrentItinerary ? "Your current itinerary" : "Previously issued itinerary"}
      </h1>
      <div className="itinerary-meta__details">
        <p className="itinerary-meta__author">
          Created for you <time>{sentTime}</time> by {author}
        </p>
        <div className={classNames( "itinerary-meta__version", { "current-itinerary" : isCurrentItinerary } ) } >
          {isCurrentItinerary ? <CircleIcon icon="icon-checkmark" /> : <CircleIcon icon="icon-history" />}          
          <span className="itinerary-meta__version-number">Itinerary #{versionNumber}</span>
        </div>
      </div>
    </header>
  );
}